import { useState } from "react";
import axios from "axios";
import { Lock } from "lucide-react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const AdminLogin = ({ onSuccess }) => {
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setError("");
    try {
      await axios.post(`${API}/admin/login`, { password }, { withCredentials: true });
      onSuccess();
    } catch (err) {
      if (err.response?.status === 401) {
        setError("Incorrect password. Please try again.");
      } else {
        setError("Something went wrong. Please try again in a moment.");
      }
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <main className="min-h-screen flex items-center justify-center bg-[#FBF9F5] px-6" data-testid="admin-login-page">
      <form onSubmit={handleSubmit} className="w-full max-w-sm p-8 rounded-2xl border border-[#4A6B56]/15 bg-[#F4F0E8]">
        <div className="flex items-center gap-2 mb-6">
          <Lock className="w-5 h-5 text-[#4A6B56]" />
          <h1 className="font-serif text-2xl text-[#1E2D24]">Admin Access</h1>
        </div>
        <input
          data-testid="admin-password-input"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="Enter admin password"
          className="w-full px-4 py-2.5 rounded-xl border border-[#4A6B56]/20 bg-white text-[#232B25] mb-3 focus:outline-none focus:ring-2 focus:ring-[#4A6B56]"
        />
        {error && (
          <p className="text-sm text-red-600 mb-3" data-testid="admin-login-error">
            {error}
          </p>
        )}
        <button
          type="submit"
          data-testid="admin-login-submit-btn"
          disabled={submitting}
          className="w-full px-6 py-3 rounded-full bg-[#4A6B56] text-white font-medium hover:opacity-90 transition-opacity disabled:opacity-60"
        >
          {submitting ? "Checking..." : "Enter"}
        </button>
      </form>
    </main>
  );
};
